import Channel from '../../classes/channel';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';
import { setChannel } from '@shared/store/thunks/channels.thunk';

export default function goToChannelMain(channel?: Channel) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.CHANNELS_MAIN },
        params: {
          current: {
            channel,
            stacked: true
          }
        }
      },
    )
    );
}
